import axios from "axios";
import { UserPreference } from "./api";

const API_BASE_URL = "/ofc/user-management/v1/preferences";

// Configure axios defaults
axios.defaults.withCredentials = true;

class UserPreferenceApiService {
  /**
   * Get current user's preferences
   */
  async getMyPreferences(): Promise<UserPreference> {
    const response = await axios.get<UserPreference>(`${API_BASE_URL}/me`);
    return response.data;
  }

  /**
   * Save or update current user's preferences
   */
  async saveMyPreferences(
    preferences: UserPreference,
  ): Promise<UserPreference> {
    const response = await axios.post<UserPreference>(
      `${API_BASE_URL}/me`,
      preferences,
    );
    return response.data;
  }

  /**
   * Update theme mode for current user
   */
  async updateTheme(themeMode: string): Promise<UserPreference> {
    const response = await axios.put<UserPreference>(
      `${API_BASE_URL}/me/theme`,
      null,
      {
        params: { themeMode },
      },
    );
    return response.data;
  }

  /**
   * Update language for current user
   */
  async updateLanguage(language: string): Promise<UserPreference> {
    const response = await axios.put<UserPreference>(
      `${API_BASE_URL}/me/language`,
      null,
      {
        params: { language },
      },
    );
    return response.data;
  }
}

export default new UserPreferenceApiService();
